import "./who-are-we-section.css";
import { useTranslation } from "react-i18next";

export default function WhoAreWe() {
  const {t} = useTranslation();
  return (
    <div>
      <p className="main-heading">{t("Who We Are")}</p>
      <h2 className="main-sub-heading">
        {t("Get to know")} <span className="gradient-text">SIGVION</span>
      </h2>
      <p className="main-description">
       {t("Sigvion is a technology company that revolutionizes the way business operates and delivers success to the clients and their business partners. With a commitment to provide high quality and unmatchable services with good turnaround times under great affordability.")}
      </p>
      <div className="mission-vision-container">
        {/* Mission Section */}
        <div className="mission-section">
          <div className="image">
            <img src="/assets/images/our-mission-img.webp" alt={t("Mission")} />
          </div>
          <div className="text">
            <h3>{t("Our Mission")}</h3>
            <p>
              {t("Our core purpose at Sigvion is to empower businesses with cutting-edge technology solutions that solve complex business problems. We are passionate about innovation and harness it to facilitate business growth and success.")}
            </p>
            <ul>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Driving Sustainable Digital Growth")}
              </li>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Innovating for a Smarter Future")}
              </li>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Customer-Centric IT Excellence")}
              </li>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Building Connected, Resilient Ecosystems")}
              </li>
            </ul>
          </div>
        </div>

        {/* Vision Section */}
        <div className="vision-section">
          <div className="text">
            <h3>{t("Our Vision")}</h3>
            <p>
              {t("Our value proposition lies in our commitment to delivering quality first. We offer world-class information technology services, with a team of technologists and Partner alliance experts available 24/7. We pride ourselves on being trusted delivery partners for all sizes of companies and across all industries.")}
            </p>
            <ul>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Commitment to Excellence")}
              </li>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Empowering Global Partnerships")}
              </li>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Putting Customers at the Core")}
              </li>
              <li>
                <i className="fa-solid fa-angles-right"></i> {t("Technology for All")}
              </li>
            </ul>
          </div>
          <div className="image">
            <img src="/assets/images/our-vision-img.webp" alt={t("Vision")} />
          </div>
        </div>

      </div>
    </div>
  );
}
